import * as Sentry from '@sentry/react';

/**
 * Initializes Sentry for the web app. Safe to call when
 * VITE_SENTRY_DSN is unset — Sentry then no-ops, so dev runs without
 * the DSN work normally.
 *
 * Tracing + replays are off for the MVP; we only want error capture
 * for pre-beta. Performance + session replay can be bumped on later
 * once we know what to act on.
 */
const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
  // Release tag is injected by the Sentry Vite plugin at build time
  // via the same short git sha used for source-map upload, so errors
  // group by deploy and the right map gets applied.
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: 0,
    // PII off: usernames/emails would land in scope without this.
    sendDefaultPii: false,
  });
}

export { Sentry };
